import React from 'react';
import { Fab, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import fscreen from 'fscreen';
import useFullScreenToggle from '../../../hooks/useFullScreenToggle/useFullScreenToggle';
import { PSYLARIS_DARK, PSYLARIS_LIGHT_GREY } from '../../../utils/Colors';

const useStyles = makeStyles<Theme>(theme => ({
  fab: {
    margin: theme.spacing(1),
    backgroundColor: PSYLARIS_LIGHT_GREY,
    color: PSYLARIS_DARK,
  },
}));

export default function ToggleFullscreenButton() {
  const classes = useStyles();
  const [isFullScreen, toggleFullScreen] = useFullScreenToggle();
  const icon = isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />;
  const fullScreenId = 'full-screen-button';

  return fscreen.fullscreenEnabled ? (
    <div>
      <Fab
        id={fullScreenId}
        type="button"
        className={classes.fab}
        size={'large'}
        onClick={() => {
          toggleFullScreen();
          document.getElementById(fullScreenId)?.blur();
        }}
      >
        {icon}
      </Fab>
    </div>
  ) : null;
}
